import { GlobalErrorHandler } from './global-error-handler.service';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { AppConfig } from '@mpt-fo/common/shared/config/app-config';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginComponent } from './channels/auth/login/login.component';
import { CoreModule } from '@mpt-fo/common/core/core.module';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ForgotPasswordComponent } from './channels/auth/forgot-password/forgot-password.component';
import { ForgotUsernameComponent } from './channels/auth/forgot-username/forgot-username.component';
import { DeviceRegistrationComponent } from './channels/auth/device-registration/device-registration.component';
import { UsernameCollectionComponent } from './channels/auth/forgot-password/partials/username-collection/username-collection.component';
import { PasswordOtpValidationComponent } from './channels/auth/forgot-password/partials/password-otp-validation/password-otp-validation.component';
import { FaceValidationComponent } from './channels/auth/forgot-password/partials/face-validation/face-validation.component';
import { DatePipe, registerLocaleData } from '@angular/common';
import { ChangePasswordComponent } from './channels/auth/change-password/change-password.component';
import { MessageModalComponent } from './channels/auth/login/partials/message-modal/message-modal.component';
import { LoginDeviceRegistrationComponent } from './channels/auth/login/partials/login-device-registration/login-device-registration.component';
import {LoginLivenessCheckComponent} from './channels/auth/login/partials/login-liveness-check/login-liveness-check.component'
import {LoginRequestLocationComponent} from './channels/auth/login/partials/login-request-location/login-request-location.component';
import { RegisterBiometricComponent } from './channels/auth/login/partials/register-biometric/register-biometric.component';
import { KamonaModule } from '@mpt-fo/common/kamona/kamona.module';
import { MobilePageNotFoundComponent } from './page-not-found/partials/mobile-page-not-found/mobile-page-not-found.component';
import { BiometricComponent } from './channels/auth/biometric/biometric.component';
import { PinComponent } from './pin/pin.component';
import { BusinessPinComponent } from './pin/business-pin/business-pin.component';
import { BusinessPinMobileComponent } from './pin/business-pin/partial/business-pin-mobile/business-pin-mobile.component';
import { BusinessPinDesktopComponent } from './pin/business-pin/partial/business-pin-desktop/business-pin-desktop.component';
import { OtpPinCreationComponent } from './pin/otp-pin-creation/otp-pin-creation.component';
import { PinGetStartedComponent } from './pin/pin-get-started/pin-get-started.component';
import { PinGetStartedMobileComponent } from './pin/pin-get-started/partial/pin-get-started-mobile/pin-get-started-mobile.component';
import { PinGetStartedDesktopComponent } from './pin/pin-get-started/partial/pin-get-started-desktop/pin-get-started-desktop.component';
import { OtpPhoneSelectorComponent } from './pin/otp-phone-selector/otp-phone-selector.component';
import { OtpPhoneSelectorDesktopComponent } from './pin/otp-phone-selector/partial/otp-phone-selector-desktop/otp-phone-selector-desktop.component';
import { OtpPhoneSelectorMobileComponent } from './pin/otp-phone-selector/partial/otp-phone-selector-mobile/otp-phone-selector-mobile.component';
import { OtpPinCreationDesktopComponent } from './pin/otp-pin-creation/partial/otp-pin-creation-desktop/otp-pin-creation-desktop.component';
import { OtpPinCreationMobileComponent } from './pin/otp-pin-creation/partial/otp-pin-creation-mobile/otp-pin-creation-mobile.component';
import { AgmCoreModule } from 'agm-core-synergi';
import { UtilitiesModule } from '@mpt-fo/common/utilities/utilities.module';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { WebLoginComponent } from './channels/auth/login/partials/web-login/web-login.component';
import { MobileLoginComponent } from './channels/auth/login/partials/mobile-login/mobile-login.component';
import { NzFormModule } from 'ng-zorro-antd/form';
import { SplashScreenComponent } from './channels/auth/login/partials/mobile-login/components/splash-screen/splash-screen.component';
import { DeviceRegistrationModalComponent } from './channels/auth/login/partials/mobile-login/components/mobile-modals/device-registration-modal/device-registration-modal.component';
import { LinkUserToMobileDeviceComponent } from './channels/auth/login/partials/mobile-login/components/link-user-mobile-device/link-user-to-mobile-device.component';
import { ErrorModalComponent } from './channels/auth/login/partials/mobile-login/components/mobile-modals/error-modal/error-modal.component';
import { PrivacyModalComponent } from './channels/auth/login/partials/mobile-login/components/mobile-modals/privacy-modal/privacy-modal.component';
import { UsernameRecoveryComponent } from './channels/auth/login/partials/mobile-login/components/credential-recovery/partials/username-recovery/username-recovery.component';
import { PasswordRecoveryComponent } from './channels/auth/login/partials/mobile-login/components/credential-recovery/partials/password-recovery/password-recovery.component';
import { PasswordRecoveryMessageComponent } from './channels/auth/login/partials/mobile-login/components/mobile-modals/password-recovery-message/password-recovery-message.component';
import { SuccessRecoveryComponent } from './channels/auth/login/partials/mobile-login/components/credential-recovery/partials/password-recovery/partials/success-recovery/success-recovery.component';
import { NoInternetConnectionComponent } from './channels/auth/login/partials/mobile-login/components/no-internet-connection/no-internet-connection.component';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { ChangeMobilePasswordComponent } from './channels/auth/login/partials/mobile-login/components/change-password/change-mobile-password.component';
import { MediaCaptureModule } from './media-capture/media-capture.module';
import zh from '@angular/common/locales/zh';
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';
import { MobileAppVersionUpgradeComponent } from './channels/auth/login/partials/mobile-login/components/mobile-app-version-upgrade/mobile-app-version-upgrade.component';
import { NeedHelpMobileComponent } from '@mpt-fo/common/kamona/components/need-help/partials/need-help-mobile/need-help-mobile.component';
import { NeedHelpComponent } from '@mpt-fo/common/kamona/components/need-help/need-help.component';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { LeanSharedModule } from '@mpt-fo/common/lean-shared/lean-shared.module';
import { BoKycLvl2IdentityTypeSelectedV2Component } from '@app/channels/onboarding/onboarding-v2/kyc-v2/partials/bo-kyc/partials/bo-kyc-lvl2/partials/bo-kyc-lvl2-identity-type-selected-v2/bo-kyc-lvl2-identity-type-selected-v2.component';
import { BoKycLvl2IdentityTypeSelectedWebV2Component } from '@app/channels/onboarding/onboarding-v2/kyc-v2/partials/bo-kyc/partials/bo-kyc-lvl2/partials/bo-kyc-lvl2-identity-type-selected-v2/partials/bo-kyc-lvl2-identity-type-selected-web-v2/bo-kyc-lvl2-identity-type-selected-web-v2.component';
import { BoKycLvl2IdentityTypeSelectedMobileV2Component } from '@app/channels/onboarding/onboarding-v2/kyc-v2/partials/bo-kyc/partials/bo-kyc-lvl2/partials/bo-kyc-lvl2-identity-type-selected-v2/partials/bo-kyc-lvl2-identity-type-selected-mobile-v2/bo-kyc-lvl2-identity-type-selected-mobile-v2.component';
import { WebLoginV2Component } from './channels/auth/login/partials/login-v2/web-login-v2/web-login-v2.component';
import { MobileLoginV2Component } from './channels/auth/login/partials/login-v2/mobile-login-v2/mobile-login-v2.component';
import { ForgetPasscodeComponent } from '@app/channels/auth/login/partials/forget-passcode/forget-passcode.component';
import { MobileForgetPasscodeComponent } from '@app/channels/auth/login/partials/forget-passcode/partials/mobile-forget-passcode/mobile-forget-passcode.component';
import { WebForgetPasscodeComponent } from '@app/channels/auth/login/partials/forget-passcode/partials/web-forget-passcode/web-forget-passcode.component';
import { MobilePhoneNumberRecoveryComponent } from '@app/channels/auth/login/partials/forget-passcode/partials/phone-number-recovery/partials/mobile-phone-number-recovery/mobile-phone-number-recovery.component';
import { WebPhoneNumberRecoveryComponent } from '@app/channels/auth/login/partials/forget-passcode/partials/phone-number-recovery/partials/web-phone-number-recovery/web-phone-number-recovery.component';
import { PhoneNumberRecoveryComponent } from '@app/channels/auth/login/partials/forget-passcode/partials/phone-number-recovery/phone-number-recovery.component';
import { ForgetPasscodeUsernameRecoveryComponent } from '@app/channels/auth/login/partials/forget-passcode/partials/forget-passcode-username-recovery/forget-passcode-username-recovery.component';
import { WebForgetPasscodeUsernameRecoveryComponent } from '@app/channels/auth/login/partials/forget-passcode/partials/forget-passcode-username-recovery/partials/web-forget-passcode-username-recovery/web-forget-passcode-username-recovery.component';
import { MobileForgetPasscodeUsernameRecoveryComponent } from '@app/channels/auth/login/partials/forget-passcode/partials/forget-passcode-username-recovery/partials/mobile-forget-passcode-username-recovery/mobile-forget-passcode-username-recovery.component';
import { ForgetPasswordComponent } from '@app/channels/auth/login/partials/forget-password/forget-password.component';
import { WebForgetPasswordComponent } from '@app/channels/auth/login/partials/forget-password/partials/web-forget-password/web-forget-password.component';
import { MobileForgetPasswordComponent } from '@app/channels/auth/login/partials/forget-password/partials/mobile-forget-password/mobile-forget-password.component';
import { MobileSignInComponent } from '@app/channels/auth/login/partials/sign-in/partials/mobile-sign-in/mobile-sign-in.component';
import { SignInComponent } from '@app/channels/auth/login/partials/sign-in/sign-in.component';
import { WebSignInComponent } from '@app/channels/auth/login/partials/sign-in/partials/web-sign-in/web-sign-in.component';
import { SignInFormComponent } from '@app/channels/auth/login/partials/sign-in/partials/sign-in-form/sign-in-form.component';
import { WebSignInFormComponent } from '@app/channels/auth/login/partials/sign-in/partials/sign-in-form/web-sign-in-form/web-sign-in-form.component';
import { MobileSignInFormComponent } from '@app/channels/auth/login/partials/sign-in/partials/sign-in-form/mobile-sign-in-form/mobile-sign-in-form.component';
import { UserDeviceRegistrationComponent } from '@app/channels/auth/login/partials/sign-in/partials/user-device-registration/user-device-registration.component';
import { MobileUserDeviceRegistrationComponent } from '@app/channels/auth/login/partials/sign-in/partials/user-device-registration/mobile-user-device-registration/mobile-user-device-registration.component';
import { WebUserDeviceRegistrationComponent } from '@app/channels/auth/login/partials/sign-in/partials/user-device-registration/web-user-device-registration/web-user-device-registration.component';
import { CookiePolicyModalComponent } from './channels/auth/login/partials/mobile-login/components/mobile-modals/cookie-policy-modal/cookie-policy-modal.component';

registerLocaleData(zh);

export function rootLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

export function configLoader(config: AppConfig) {
    return () => config.load();
}

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        PageNotFoundComponent,
        ForgotPasswordComponent,
        ForgotUsernameComponent,
        DeviceRegistrationComponent,
        UsernameCollectionComponent,
        PasswordOtpValidationComponent,
        FaceValidationComponent,
        ChangePasswordComponent,
        MessageModalComponent,
        LoginDeviceRegistrationComponent,
        LoginLivenessCheckComponent,
        LoginRequestLocationComponent,
        RegisterBiometricComponent,
        MobilePageNotFoundComponent,
        BiometricComponent,
        PinComponent,
        BusinessPinComponent,
        BusinessPinMobileComponent,
        BusinessPinDesktopComponent,
        OtpPinCreationComponent,
        PinGetStartedComponent,
        PinGetStartedMobileComponent,
        PinGetStartedDesktopComponent,
        OtpPhoneSelectorComponent,
        OtpPhoneSelectorDesktopComponent,
        OtpPhoneSelectorMobileComponent,
        OtpPinCreationDesktopComponent,
        OtpPinCreationMobileComponent,
        WebLoginComponent,
        MobileLoginComponent,
        LoginComponent,
        SplashScreenComponent,
        DeviceRegistrationModalComponent,
        LinkUserToMobileDeviceComponent,
        ErrorModalComponent,
        PrivacyModalComponent,
        UsernameRecoveryComponent,
        PasswordRecoveryComponent,
        PasswordRecoveryMessageComponent,
        SuccessRecoveryComponent,
        ChangePasswordComponent,
        NoInternetConnectionComponent,
        ChangeMobilePasswordComponent,
        MobileAppVersionUpgradeComponent,
        NeedHelpComponent,
        NeedHelpMobileComponent,
        BoKycLvl2IdentityTypeSelectedV2Component,
        BoKycLvl2IdentityTypeSelectedWebV2Component,
        BoKycLvl2IdentityTypeSelectedMobileV2Component,
        WebLoginV2Component,
        MobileLoginV2Component,
        ForgetPasscodeComponent,
        MobileForgetPasscodeComponent,
        WebForgetPasscodeComponent,
        MobilePhoneNumberRecoveryComponent,
        WebPhoneNumberRecoveryComponent,
        PhoneNumberRecoveryComponent,
        ForgetPasscodeUsernameRecoveryComponent,
        WebForgetPasscodeUsernameRecoveryComponent,
        MobileForgetPasscodeUsernameRecoveryComponent,
        ForgetPasswordComponent,
        WebForgetPasswordComponent,
        MobileForgetPasswordComponent,
        MobileSignInComponent,
        SignInComponent,
        WebSignInComponent,
        SignInFormComponent,
        WebSignInFormComponent,
        MobileSignInFormComponent,
        UserDeviceRegistrationComponent,
        WebUserDeviceRegistrationComponent,
        MobileUserDeviceRegistrationComponent,
        CookiePolicyModalComponent,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        ReactiveFormsModule,
        NzDividerModule,
        HttpClientModule,
        NzCardModule,
        BrowserAnimationsModule,
        CoreModule,
        MediaCaptureModule,
        NzGridModule,
        NzButtonModule,
        NzListModule,
        NzPaginationModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: rootLoaderFactory,
                deps: [HttpClient],
            },
        }),
        KamonaModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyBRdXreiqf0s-ak95kUG_Ws_3ms7CfG5QE',
        }),
        UtilitiesModule,
        NzToolTipModule,
        NzIconModule,
        NzInputModule,
        NzFormModule,
        NzProgressModule,
        FormsModule,
        NzCollapseModule,
        LeanSharedModule,
    ],
    providers: [
        AppConfig,
        {
            provide: APP_INITIALIZER,
            useFactory: configLoader,
            deps: [AppConfig],
            // tslint:disable-next-line:indent
            multi: true,
        },
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandler,
        },
        DatePipe,
        { provide: NZ_I18N, useValue: en_US },
    ],
    exports: [DeviceRegistrationComponent, NeedHelpComponent, ErrorModalComponent],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
